// @flow
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Layout, Popover, Button, Icon } from "antd";
import Media from "react-media";
import FaFilter from "react-icons/lib/fa/filter";
import SearchPanel from "../searchpanel";
import MasonryList from "../masonrylist";
import DetailsView from "./../detailsview";
import type { User } from "../../reducers/auth";
import type { State } from "../../types/store";
import * as actions from "../../actions";
import PrivateRoute from "./../privateroute";
import "./grid.css";
const { Content, Sider, Header } = Layout;

type Props = {
  user: User,
  total: number,
  editMode: boolean,
  onToggleEditMode: Function
};

const GridView = ({ user, total, editMode, onToggleEditMode }: Props) => {
  return (
    <Media query="(max-width: 768px)">
      {matches => (
        <Layout className="main-layout padding-for-nav">
          {!matches && ( // desktop of search panel
            <Sider
              className="search-panel"
              breakpoint="sm"
              collapsedWidth="0"
              width="250"
            >
              <SearchPanel />
            </Sider>
          )}
          <Content className="gallery">
            <Header
              className={"grid-header " + (matches ? "grid-header-mobile" : "")}
            >
              {matches && ( // mobile of search panel
                <Popover
                  overlayClassName="popover-search-mobile"
                  placement="bottomRight"
                  content={<SearchPanel />}
                  trigger="click"
                >
                  <Button className="menu-btn">
                    <FaFilter />
                  </Button>
                </Popover>
              )}
              <span style={{ flex: 1 }}>{total} Items found</span>
              {user.role === "admin" && (
                <Button onClick={onToggleEditMode}>
                  <Icon type="edit" /> {editMode ? "Cancel Edit" : "Edit"}
                </Button>
              )}
            </Header>
            <MasonryList />
            <PrivateRoute
              path="/details/:itemId"
              component={DetailsView}
              user={user}
            />
          </Content>
        </Layout>
      )}
    </Media>
  );
};

function mapStateToProps(state: State) {
  const { user } = state.auth;
  const { total, editMode } = state.items;
  return {
    user,
    total,
    editMode
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onToggleEditMode: bindActionCreators(actions.toggleEditMode, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GridView);



// WEBPACK FOOTER //
// ./src/components/gridview/index.js